// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `app-root .carousel {
  min-height: 3rem;
}
app-root .carousel input.carousel-toggle {
  -webkit-appearance: none;
  appearance: none;
  /* For iOS < 15 */
  background-color: var(--background-grey);
  margin: 0;
  position: relative;
  top: 50%;
  width: 1em;
  height: 1em;
  font: inherit;
  color: currentColor;
  border: 0.0625em solid currentColor;
  border-radius: 50%;
  background: none;
  color: #d7918e;
  width: 0.6rem;
  height: 0.6rem;
  margin-right: 1rem;
  border-width: 0.1rem;
  cursor: pointer;
}
app-root .carousel input.carousel-toggle::before {
  will-change: transform;
  position: relative;
  display: block;
  z-index: 3;
  border-radius: 50%;
  transform: scale(0);
  transition: transform 0.15s ease-in-out;
  box-shadow: inset 1em 1em var(--selection-grey);
  /* Windows High Contrast Mode */
  background-color: CanvasText;
}
app-root .carousel input.carousel-toggle::before {
  content: '';
  width: 0.5em;
  height: 0.5em;
  top: 0.1875em;
  left: 0.1875em;
}
app-root .carousel input.carousel-toggle:checked::before {
  transform: scale(1);
}
app-root .carousel input.carousel-toggle:last-of-type {
  margin-right: unset;
}
app-root .carousel input.carousel-toggle:checked {
  color: #d7918e;
}
app-root .carousel input.carousel-toggle::before {
  width: 0.6rem;
  height: 0.6rem;
  top: -0.1rem;
  left: -0.1rem;
  box-shadow: inset 0.6rem 0.6rem white;
}
`, "",{"version":3,"sources":["webpack://./src/Components/UI/Carousel/Carousel.less","webpack://./src/Components/Form/Inputs/Generic/Multi/Utilities/baseStyle.less"],"names":[],"mappings":"AAEA;EAEI,gBAAA;AAFJ;AAAA;ECAE,wBAAA;EACA,gBAAA;EDGA,iBAAiB;ECDjB,wCAAA;EACA,SAAA;EAEA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;EAEA,aAAA;EACA,mBAAA;EACA,mCAAA;EACA,kBAAA;EDRI,gBAAA;EACA,cAAA;EACA,aAAA;EACA,cAAA;EACA,kBAAA;EACA,oBAAA;EAEA,eAAA;AASN;ACNE;EACE,sBAAA;EACA,kBAAA;EACA,cAAA;EACA,UAAA;EACA,kBAAA;EACA,mBAAA;EACA,uCAAA;EACA,+CAAA;EDQF,+BAA+B;ECL7B,4BAAA;ADOJ;ACiBE;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,aAAA;EACA,cAAA;ADfJ;ACkBE;EACE,mBAAA;ADhBJ;AA7BM;EACE,mBAAA;AA+BR;AA7BM;EACE,cAAA;AA+BR;AA7BM;EACE,aAAA;EACA,cAAA;EACA,YAAA;EACA,aAAA;EACA,qCAAA;AA+BR","sourcesContent":["@import '../../../Components/Form/Inputs/Generic/Multi/Utilities/baseStyle.less';\n\napp-root {\n  .carousel {\n    min-height: 3rem; // override this to match actual content +  controls height\n    input.carousel-toggle {\n      .shared-multi-input-styles();\n      .radio-input-styles();\n      background: none;\n      color: #d7918e;\n      width: 0.6rem;\n      height: 0.6rem;\n      margin-right: 1rem;\n      border-width: 0.1rem;\n\n      cursor: pointer;\n\n      &:last-of-type {\n        margin-right: unset;\n      }\n      &:checked {\n        color: #d7918e;\n      }\n      &::before {\n        width: 0.6rem;\n        height: 0.6rem;\n        top: -0.1rem;\n        left: -0.1rem;\n        box-shadow: inset 0.6rem 0.6rem white;\n      }\n    }\n  }\n}\n",".shared-multi-input-styles() {\n  // Resets\n  -webkit-appearance: none;\n  appearance: none;\n  /* For iOS < 15 */\n  background-color: var(--background-grey);\n  margin: 0;\n\n  position: relative;\n  top: 50%;\n  width: 1em;\n  height: 1em;\n\n  font: inherit;\n  color: currentColor;\n  border: 0.0625em solid currentColor;\n  border-radius: 50%;\n\n  &::before {\n    will-change: transform;\n    position: relative;\n    display: block;\n    z-index: 3;\n    border-radius: 50%;\n    transform: scale(0);\n    transition: transform 0.15s ease-in-out;\n    box-shadow: inset 1em 1em var(--selection-grey);\n\n    /* Windows High Contrast Mode */\n    background-color: CanvasText;\n  }\n}\n\n.checkbox-input-styles() {\n  &::before {\n    content: url(\"data: image/svg+xml,%3Csvg width='10' height='9' viewBox='0 0 10 9' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 5L3.5 7.5L9 1' stroke='white' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' /%3E%3C/svg%3E\");\n    color: white;\n    width: 1em;\n    height: 1em;\n    line-height: 0.95em;\n    text-align: center;\n    top: -0.0625em;\n    left: -0.0625em;\n    transform: scale(0) rotate(-30deg);\n    transition-duration: 0.1s;\n  }\n\n  &:checked::before {\n    transform: scale(1);\n  }\n}\n\n.radio-input-styles() {\n  &::before {\n    content: '';\n    width: 0.5em;\n    height: 0.5em;\n    top: 0.1875em;\n    left: 0.1875em;\n  }\n\n  &:checked::before {\n    transform: scale(1);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
